import { FormattedMessage } from 'react-intl';
import { PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';
import { Table, TableCell, TableRow } from '@mui/material';

import { RowArticle } from './row-article';
import { SupplierTableBody } from '../../../../components/supplier-table/supplier-table-body';
import { SupplierTableHead } from '../../../../components/supplier-table/supplier-table-head';
import { WishListSupplier } from '../../../../models/wish-list';

export interface SupplierTableProps {
    supplier: WishListSupplier;
}

export const SupplierTableDesktop = (props: SupplierTableProps): ReactElement => {
    const { supplier } = props;

    return (
        <Table>
            <SupplierTableHead>
                <TableRow>
                    <TableCell>
                        <PoolTypography typography="subtitle1" sx={{ fontWeight: 600 }}>
                            {supplier?.name}
                        </PoolTypography>
                    </TableCell>
                    <TableCell align="right">
                        <FormattedMessage id="app.cart.supplier.singlePrice" />
                    </TableCell>
                    <TableCell align="right">
                        <FormattedMessage id="app.cart.supplier.pricePerArticle" />
                    </TableCell>
                    <TableCell />
                </TableRow>
            </SupplierTableHead>
            <SupplierTableBody>
                {supplier.items.map(item => {
                    return (
                        <RowArticle
                            key={item.product.id}
                            cartItem={item}
                            previewImage={item.previewImage?.['200x200'] ?? supplier.image?.['200x200']}
                        />
                    );
                })}
            </SupplierTableBody>
        </Table>
    );
};
